import { Controller } from 'react-hook-form';
import { Inputs, Label } from 'components';
import { FormAutoSuggestDropdownCheckboxStyled } from './styled';

const FormAutoSuggestDropdownCheckbox = ({
  control,
  name,
  label,
  required = false,
  subLabel,
  errors,
  options = [],
  placeholder = 'เลือก',
  onChangeCustom,
  disabled,
  showAllOption = true,
  showSearch = true,
  fetchApi,
  category,
  params,
  heightInput,
  fontSize,
  minwidth,
  placeholderDropdownAll,
  maxLength,
  iconColor,
  ...rest
}) => (
  <FormAutoSuggestDropdownCheckboxStyled>
    <div className="box_input_item">
      <Label.LabelForm label={label} required={required} subLabel={subLabel} />
      <Controller
        control={control}
        name={name}
        defaultValue={[]}
        render={({ field }) => (
          <Inputs.AutoSuggestDropdownCheckbox
            {...rest}
            theme_autosugget
            options={options}
            placeholderDropdown={placeholder}
            disabled={disabled}
            errors={errors}
            showAllOption={showAllOption}
            showSearch={showSearch}
            fetchApi={fetchApi}
            category={category}
            params={params}
            heightInput={heightInput}
            fontSize={fontSize}
            minwidth={minwidth}
            placeholderDropdownAll={placeholderDropdownAll}
            maxLength={maxLength}
            iconColor={iconColor}
            value={field.value}
            onChange={(selectedValues) => {
              field.onChange(selectedValues);
              onChangeCustom && onChangeCustom(selectedValues);
            }}
          />
        )}
      />
    </div>
  </FormAutoSuggestDropdownCheckboxStyled>
);

export default FormAutoSuggestDropdownCheckbox;
